"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imperfections = exports.Weight = exports.otherSupplyTypeOrdered = exports.otherSupplyType = exports.KnownOrEstimated = exports.osSize = exports.DimensionDescription = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["By Meter"] = "By Meter";
    SellingUnit["Individual"] = "Individual";
    SellingUnit["Pack"] = "Pack";
    SellingUnit["By Weight"] = "By Weight";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var DimensionDescription;
(function (DimensionDescription) {
    DimensionDescription["Package"] = "The Package";
    DimensionDescription["Individual"] = "Individual Pieces";
})(DimensionDescription = exports.DimensionDescription || (exports.DimensionDescription = {}));
var osSize;
(function (osSize) {
    osSize["Small"] = "Small";
    osSize["Medium"] = "Medium";
    osSize["Large"] = "Large";
})(osSize = exports.osSize || (exports.osSize = {}));
var KnownOrEstimated;
(function (KnownOrEstimated) {
    KnownOrEstimated["Known"] = "Known";
    KnownOrEstimated["Estimated"] = "Estimated";
})(KnownOrEstimated = exports.KnownOrEstimated || (exports.KnownOrEstimated = {}));
var otherSupplyType;
(function (otherSupplyType) {
    otherSupplyType["Velcro"] = "Velcro";
    otherSupplyType["Sewing Tool"] = "Sewing Tool";
    otherSupplyType["Quilting"] = "Quilting";
    otherSupplyType["Feathers"] = "Feathers";
    otherSupplyType["Sequins"] = "Sequins";
    otherSupplyType["Beads"] = "Beads";
    otherSupplyType["Felt"] = "Felt";
    otherSupplyType["Yarn"] = "Yarn";
    otherSupplyType["Costume Jewelry"] = "Costume Jewelry";
    otherSupplyType["Bridal Wear"] = "Bridal Wear";
    otherSupplyType["Clothing"] = "Clothing";
    otherSupplyType["Books"] = "Books";
    otherSupplyType["Tools"] = "Tools";
    otherSupplyType["Notions"] = "Notions";
    otherSupplyType["Applique"] = "Applique";
    otherSupplyType["Accessories"] = "Accessories";
})(otherSupplyType = exports.otherSupplyType || (exports.otherSupplyType = {}));
var otherSupplyTypeCategory;
(function (otherSupplyTypeCategory) {
    otherSupplyTypeCategory["Sewing"] = "Sewing";
    otherSupplyTypeCategory["Craft"] = "Craft";
    otherSupplyTypeCategory["Other"] = "Other";
})(otherSupplyTypeCategory || (otherSupplyTypeCategory = {}));
exports.otherSupplyTypeOrdered = {
    [otherSupplyTypeCategory.Sewing]: {
        [otherSupplyType.Velcro]: otherSupplyType.Velcro,
        [otherSupplyType['Sewing Tool']]: otherSupplyType['Sewing Tool'],
        [otherSupplyType.Quilting]: otherSupplyType.Quilting
    },
    [otherSupplyTypeCategory.Craft]: {
        [otherSupplyType.Feathers]: otherSupplyType.Feathers,
        [otherSupplyType.Sequins]: otherSupplyType.Sequins,
        [otherSupplyType.Beads]: otherSupplyType.Beads,
        [otherSupplyType.Felt]: otherSupplyType.Felt,
        [otherSupplyType.Yarn]: otherSupplyType.Yarn
    },
    [otherSupplyTypeCategory.Other]: {
        [otherSupplyType['Costume Jewelry']]: otherSupplyType['Costume Jewelry'],
        [otherSupplyType['Bridal Wear']]: otherSupplyType['Bridal Wear'],
        [otherSupplyType.Clothing]: otherSupplyType.Clothing,
        [otherSupplyType.Books]: otherSupplyType.Books,
        [otherSupplyType.Tools]: otherSupplyType.Tools,
        [otherSupplyType.Notions]: otherSupplyType.Notions,
        [otherSupplyType.Applique]: otherSupplyType.Applique,
        [otherSupplyType.Accessories]: otherSupplyType.Accessories
    }
};
var Weight;
(function (Weight) {
    Weight["Light"] = "Light";
    Weight["Medium"] = "Medium";
    Weight["Heavy"] = "Heavy";
})(Weight = exports.Weight || (exports.Weight = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Marks"] = "Marks";
    Imperfections["Vintage Scent"] = "Vintage Scent";
    Imperfections["Dusty"] = "Dusty";
    Imperfections["Discoloured"] = "Discoloured";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
//# sourceMappingURL=otherSupplyAttributes.js.map